import splitTimes from '@medical/constant/splitTimes'
import {
  formatExtendedTime,
  isNextDayTime,
} from '@medical/libs/extendedTimeUtils'
import moment from 'moment'
import { AutoComplete } from '../../../../fork/primereact/autocomplete'
import React, { useEffect, useState } from 'react'

/**
 * Format a Date/moment value to display string, supporting extended hours (24:xx, 25:xx).
 * If baseDate is provided and the value falls on the next day, shows extended format.
 */
const formatDisplayTime = (valueProp, baseDate) => {
  // CODE CU: if (baseDate && isNextDayTime(baseDate, valueProp)) { ... }
  //   -> khi baseDate khong phai 1 ngay hop le (vd id thu trong tuan "1"),
  //      moment(baseDate) Invalid -> isNextDayTime/formatExtendedTime tra ket qua sai.
  // CODE MOI: them guard moment(baseDate).isValid() truoc khi dung baseDate lam moc.
  if (
    baseDate &&
    moment(baseDate).isValid() &&
    isNextDayTime(baseDate, valueProp)
  ) {
    return formatExtendedTime(baseDate, valueProp)
  }
  return moment(valueProp).format('HH:mm')
}

/**
 * Find the index of a time string in splitTimes array.
 * For extended times (24:xx, 25:xx), converts the moment to extended format first.
 */
const findTimeIndex = (dateValue, baseDate) => {
  const timeStr = formatDisplayTime(dateValue, baseDate)
  return splitTimes.indexOf(timeStr)
}

const SplitsAutoComplete = ({
  value: valueProp,
  onChange,
  disabled,
  minDate,
  baseDate,
}) => {
  const minIndex = minDate
    ? Math.max(findTimeIndex(minDate, baseDate), 0)
    : 0
  const allSuggestions = splitTimes.slice(minIndex, splitTimes.length)
  const [suggestions, setSuggestions] = useState(allSuggestions)
  const [value, setValue] = useState(formatDisplayTime(valueProp, baseDate))

  useEffect(() => {
    setValue(formatDisplayTime(valueProp, baseDate))
  }, [valueProp, baseDate])

  useEffect(() => {
    const newMinIndex = minDate
      ? Math.max(findTimeIndex(minDate, baseDate), 0)
      : 0
    const newSuggestions = splitTimes.slice(newMinIndex, splitTimes.length)
    setSuggestions(newSuggestions)
  }, [minDate, baseDate])

  return (
    <AutoComplete
      value={value}
      suggestions={suggestions}
      completeMethod={e => {
        const results = allSuggestions.filter(item =>
          item.startsWith(e.query.toLowerCase())
        )
        setSuggestions(results)
      }}
      onChange={e => {
        let value = e.value
        const reg = /^\d+$/
        const regex = new RegExp(reg)
        if (value.match(regex) && value.length > 3) {
          const hour = value.slice(0, 2)
          const minute = value.slice(2, 4)

          value = `${hour}:${minute}`
        }
        setValue(value)
        const has = allSuggestions.some(item => item === value)
        if (has) {
          const times = value.split(':')
          const hours = parseInt(times[0], 10)
          const minutes = parseInt(times[1], 10)

          if (hours >= 24) {
            // Extended time: create a Date on the next day
            // CODE CU: const base = baseDate ? moment(baseDate).startOf('day') : moment(valueProp).startOf('day')
            //   -> baseDate khong hop le (vd "1") -> moment(baseDate) Invalid -> newDate Invalid Date.
            // CODE MOI: chi dung baseDate khi hop le, nguoc lai fallback ve valueProp.
            const base =
              baseDate && moment(baseDate).isValid()
                ? moment(baseDate).startOf('day')
                : moment(valueProp).startOf('day')
            const newDate = base
              .clone()
              .add(1, 'day')
              .hour(hours - 24)
              .minute(minutes)
              .second(0)
              .toDate()
            onChange({ value: newDate })
          } else {
            // Anchor the day to baseDate (the shift's base day), same as the
            // overnight branch above. Avoids inheriting a stale/wrong day from
            // valueProp (e.g. the form-default day "1" when the URL has no `day`),
            // which made split times land on a different day than start/end.
            const base =
              baseDate && moment(baseDate).isValid()
                ? moment(baseDate).startOf('day')
                : moment(valueProp).startOf('day')
            const newDate = base
              .clone()
              .hour(hours)
              .minute(minutes)
              .second(0)
              .toDate()
            onChange({ value: newDate })
          }
        }
      }}
      onBlur={() => {
        const results = allSuggestions.some(item => item === value)
        if (!results) {
          const times = allSuggestions[0].split(':')
          const hours = parseInt(times[0], 10)
          const minutes = parseInt(times[1], 10)

          if (hours >= 24) {
            // CODE CU: const base = baseDate ? moment(baseDate).startOf('day') : moment(valueProp).startOf('day')
            //   -> baseDate khong hop le -> Invalid Date. CODE MOI: guard moment(baseDate).isValid().
            const base =
              baseDate && moment(baseDate).isValid()
                ? moment(baseDate).startOf('day')
                : moment(valueProp).startOf('day')
            const newDate = base
              .clone()
              .add(1, 'day')
              .hour(hours - 24)
              .minute(minutes)
              .second(0)
              .toDate()
            onChange({ value: newDate })
          } else {
            // Anchor the day to baseDate (the shift's base day), same as the
            // overnight branch above. Avoids inheriting a stale/wrong day from
            // valueProp (e.g. the form-default day "1" when the URL has no `day`),
            // which made split times land on a different day than start/end.
            const base =
              baseDate && moment(baseDate).isValid()
                ? moment(baseDate).startOf('day')
                : moment(valueProp).startOf('day')
            const newDate = base
              .clone()
              .hour(hours)
              .minute(minutes)
              .second(0)
              .toDate()
            onChange({ value: newDate })
          }
        }
      }}
      disabled={disabled}
      className='split-autocomplete'
      dropdown
      // readonly
    />
  )
}

export default SplitsAutoComplete
